// cookColors — stable per-cook color palette.
//
// Every active cook session hashes deterministically to one of N
// high-mutual-contrast color pairs. The same cook always reads in
// the same color across every surface that displays it: the banner
// tab, the banner accent, the lock-screen-shape card on Home, the
// CookActivityCard's progress bar tint, etc.
//
// Picking a color belongs in ONE module so that surface-to-surface
// consistency is a property of the system, not of careful copy/paste.
// Previously this lived inline in OtherCooksStrip; promoted out as
// the strip is being removed and multiple surfaces (banner + cards)
// need the same palette.

export const COOK_COLORS = [
  { ring: "#3D6BB8", tint: "rgba(61,107,184,0.10)"  }, // cobalt
  { ring: "#C25A7A", tint: "rgba(194,90,122,0.10)"  }, // rose
  { ring: "#7A8B4A", tint: "rgba(122,139,74,0.10)"  }, // olive
  { ring: "#D4A637", tint: "rgba(212,166,55,0.10)"  }, // amber
  { ring: "#7A4E2D", tint: "rgba(122,78,45,0.10)"   }, // plum
  { ring: "#2F8F83", tint: "rgba(47,143,131,0.10)"  }, // teal
  { ring: "#A8553A", tint: "rgba(168,85,58,0.10)"   }, // rust
  { ring: "#5A6B7A", tint: "rgba(90,107,122,0.10)"  }, // slate
];

// Fast deterministic hash of a string to a palette index. uuid-shaped
// session ids spread evenly across the 8 buckets so a typical 2–4
// cook scenario gets distinct colors.
export function pickCookColor(sessionId) {
  const s = String(sessionId || "");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return COOK_COLORS[h % COOK_COLORS.length];
}
